module.exports = __webpack_public_path__ + "img/miniBomb.541cc661.svg";